"use client"
import ImageCustom from "@/components/Image";
import LinkCustomized from "@/components/shared/LinkCustomized";
import { BlockType } from "@/libs/types";
import clsx from "clsx";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";

interface LogoGridOneProps {
    locale: string
    block: BlockType
}
const LogoGridOne: React.FC<LogoGridOneProps> = ({ locale, block }) => {
    return (
        <>
            <div className={clsx('logo-grid-one', block.classes)} id={`logo-grid-one-${block.id}`}>
                <Container fluid={block.fullwidth}>
                    {block.title && (<Row className="justify-content-center text-center my-5 ">
                        <Col md={8} xs={12}>
                            <h3>{block.title}</h3>
                        </Col>
                    </Row>)}
                    <Row className="justify-content-center">
                        {(block.blocks && (block.blocks.length !== 0)) && block.blocks.map((item: any, index: number) => {
                            return (
                                <Col md={2} sm={4} xs={6} key={index}>
                                    <div className={clsx('logo-thumb object-fit-cover', item.classes)}>
                                        {item.linked.length > 0 && (
                                            <LinkCustomized
                                                locale={locale}
                                                linked={item.linked[0]}
                                                className={clsx(item.linked[0].button ? "btn-primary" : "")}
                                            >
                                                <ImageCustom src={item.thumb} width={185} height={105} alt={item.title} />
                                            </LinkCustomized>
                                        )}
                                        {item.linked.length === 0 && (
                                            <ImageCustom src={item.thumb} width={185} height={105} alt={item.title} />
                                        )}
                                    </div>
                                </Col>
                            )
                        })}
                    </Row>
                </Container>
            </div>
            <style jsx global>{`
              .logo-grid-one {
                .logo-thumb {
                  position: initial;
                  // filter: grayscale(100%);
                  display: flex;
                  // &:hover {
                  //     filter: grayscale(0%)
                  // }
                  mix-blend-mode: multiply;
                }
              }
            `}</style>
        </>
    )
}

export default LogoGridOne
